export default __webpack_public_path__ + "static/media/herringBonePattern.d5c34c6b.png";